// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-product-detail-swiper]');

    this.swiperOptions = {
      direction: 'horizontal'
    }

    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    });
    Fancybox.bind("[data-fancybox]", {
      animated: false,
      showClass: false
    });
  }
}

if(!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper);
}

class productInfo extends HTMLElement {

  constructor() {
    super();
    this.productForm = this.querySelector('product-form');
    this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
    this.quantityInput = this.querySelector('quantity-input');
    this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
    this.quantityInputElement?.addEventListener('change', () => {
      this.handleQuantityInput();
    })
    this.productATC = this.querySelector('[data-product-atc]');
    this.productATCwrapper = this.productATC.parentElement;
    this.init();
  }

  init() {
    const self = this

    // Set height of wrapper to prevent jumping content below
    self.setATCheight();
    window.addEventListener("resize", self.debounce(function(e){
      self.setATCheight();
    }));

    // Fix ATC if not in viewport
    self.fixATC();
    document.addEventListener('scroll', function () {
      self.fixATC();
    }, {
      passive: true
    });
  }

  fixATC() {
    this.isInViewport(this.productATCwrapper) ?
      this.productATC.classList.remove('fixed') :
      this.productATC.classList.add('fixed')
  }

  debounce(func){
    var timer;
    return function(event){
      if(timer) clearTimeout(timer);
      timer = setTimeout(func,100,event);
    };
  }

  /**
   * handleQuantityInput
   * @description Set the quantity from the quantity input web component to the product form web component.
   */
  handleQuantityInput() {
    this.productFormQuantity.value = this.quantityInputElement.value;
  }

  setATCheight() {
    const rect = this.productATC.getBoundingClientRect();
    this.productATCwrapper.style.minHeight = rect.height + 'px';
  }

  isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= (rect.height * -1 + 80) &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

}

if(!customElements.get('product-info')) {
  customElements.define('product-info', productInfo);
}
